import { CreateResetPasswordSchema } from 'commons/passwordChange';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useCreateResetPasswordSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = CreateResetPasswordSchema({
    RequiredMessage: t('Validate_Required'),
    NoFullWidthMessage: t('Validate_NoFullWidth'),
    MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
  });
  return schema;
};
